let title = ' | Gestor - Comercial Ivaiporã'

const gestaoRotativos = {
    path: '/gestao-rotativos',
    component: () => import('@/Components/GestaoRotativos/GestaoPerdasEstoqueContainer.vue'),
    children: [
        {
            path: '',
            redirect: 'dashboard'
        },

        // Análises
        {
            path: 'dashboard',
            name: 'DashboardInicial',
            component: () => import('@/Components/GestaoRotativos/Dashboard.vue'),
            meta: {
                title: 'Gestao de Rotativos' + title,
                permission: 'central_bi_menu_gestao_rotativos',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Gestão de Rotativos',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '/filial',
                    }
                ]
            }
        },
    ]
}

export default gestaoRotativos